import { render, staticRenderFns } from "./UtxoStakeable.vue?vue&type=template&id=1215fcec&scoped=true&"
import script from "./UtxoStakeable.vue?vue&type=script&lang=ts&"
export * from "./UtxoStakeable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1215fcec",
  null
  
)

export default component.exports